import { render, staticRenderFns } from "./pro-action-more-item.vue?vue&type=template&id=f8f9cbcc";
import script from "./pro-action-more-item.vue?vue&type=script&lang=js";
export * from "./pro-action-more-item.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;